<template>
  <div>
    <vs-chip class="mt-2" v-if="status" :class="statusModifier.label + ' text-white'">
      {{statusModifier.text }}
    </vs-chip>
  </div>
</template>

<script>
import {
  STATUS_DONE,
  STATUS_UNDONE,
  STATUS_VERIFICATION
} from "@/const/complaint";

export default {
  props: {
    status: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      statusList: [
        {
          comparison: STATUS_UNDONE,
          label: 'vs-chip-primary',
          text: 'Belum Ditindaklanjuti',
        },
        {
          comparison: STATUS_VERIFICATION,
          label: 'vs-chip-primary',
          text: 'Dalam Proses Verifikasi',
        },
        {
          comparison: STATUS_DONE,
          label: 'vs-chip-success',
          text: 'Selesai',
        },
      ]
    };
  },
  computed: {
    statusModifier() {
      return this.statusList.find(({ comparison }) => {
        return comparison == this.status;
      });
    }
  }
};
</script>
